import Iconify, { type IconifyProps } from 'components/Iconify';

type Props = Omit<IconifyProps, 'icon'>;

export const NoteIcon = (props: Props) => {
  return <Iconify icon="clarity:note-line" {...props} />;
};
